<template>
  <div>
    <div class="r-text-intro">פרטים אישיים | ת.ז. ביומטרית</div>
    <div class="r-text-headline">העלאת צד קדמי של התעודה</div>
    <social-id-part-uploader
      :social-id-upload-url="socialIdUploadUrl"
      :social-id-files="socialIdFiles"
      part-name="front"
      part-name-hebrew="צד קדמי"
      preload-success-text="צד קדמי הועלה בהצלחה!"
      @observe="observe"
      v-on="$listeners" />

    <div class="r-text-headline">העלאת צד אחורי</div>
    <social-id-part-uploader
      :social-id-upload-url="socialIdUploadUrl"
      :social-id-files="socialIdFiles"
      part-name="back"
      part-name-hebrew="צד אחורי"
      preload-success-text="צד אחורי הועלה בהצלחה!"
      @observe="observe"
      v-on="$listeners" />

    <div class="r-text-headline">העלאת ספח</div>
    <social-id-part-uploader
      :social-id-upload-url="socialIdUploadUrl"
      :social-id-files="socialIdFiles"
      part-name="annex"
      part-name-hebrew="ספח"
      preload-success-text="ספח הועלה בהצלחה!"
      @observe="observe"
      v-on="$listeners" />
  </div>

</template>

<script>
import SocialIdPartUploader from '@/components/SocialIdPartUploader';
import ValidationObserver from '@/mixins/ValidationObserver';

export default {
  name: 'UploadBiometricId',
  components: { SocialIdPartUploader },
  mixins: [ValidationObserver],
  props: {
    socialIdUploadUrl: {
      type: String,
      required: true,
    },
    socialIdFiles: Object,
  },
};
</script>

<style lang="scss" scoped>
.r-text-headline {
  margin-bottom: 13px;
}
</style>
